import { Box, ContentLoader } from "@bca/ui-library";
import React from "react";

const FiltersMobileLoader = () => {
  return (
    <Box
      key="index"
      display="flex"
      justifyContent="flex-end"
      alignSelf="flex-end"
      paddingX="0"
      paddingTop="48px"
      paddingBottom="20px"
    >
      <ContentLoader width="158px" height="18px">
        <rect width="19px" height="19px" rx={4} ry={4}></rect>
        <rect width="134px" height="19px" x="24px" rx={4} ry={4}></rect>
      </ContentLoader>
    </Box>
  );
};

export default FiltersMobileLoader;
